import { alertAnatomy } from '@chakra-ui/anatomy';

export const ALERT_PARTS = alertAnatomy.keys;
